import React from "react";
import { Input } from "antd";
import { SearchIcon } from "icons/Icons";
import { IFilterValues } from "domain/order";
import { ColumnType } from "antd/lib/table";

interface RoamingItemsFilterColumnsProps<T> {
  columns: ColumnType<T>[];
  searchValues: IFilterValues;
  handleFilterChange: (e: React.ChangeEvent<HTMLInputElement>, dataIndex: string) => void;
}

function RoamingItemsFilterColumns<T extends object>({
  columns,
  searchValues,
  handleFilterChange,
}: RoamingItemsFilterColumnsProps<T>): ColumnType<T>[] {
  return columns.map((column) => {
    const columnIndex = column?.dataIndex || column?.key as string | undefined;
    if (!columnIndex || !column.title) return column;

    const isActionColumn =
      typeof column.title === "string" && column.title.toLowerCase() === "actions";

    return {
      ...column,
      filterDropdownVisible: false,
      title: (
        <div>
          {typeof column.title === "function" ? column.title({}) : column.title}
          {!isActionColumn && <Input
            placeholder={`Search ${column.title}`}
            style={{
              width: "100%",
              marginBottom: 8,
              paddingRight: "6px",
              display: "block",
              marginTop: "10px",
            }}
            onClick={(e: React.MouseEvent) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            value={searchValues[columnIndex as keyof IFilterValues] || ""}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              e.preventDefault();
              e.stopPropagation();
              handleFilterChange(e, columnIndex as string);
            }}
          />}
        </div>
      ),
      filterIcon: (filtered: boolean) => (
        <SearchIcon fill={filtered ? "#1890ff" : undefined} />
      ),
    };
  });
};

export default RoamingItemsFilterColumns;